import type { ICellRendererParams } from "ag-grid-community";
import { Tag } from "@synthesis/shared-ui";

import type { ConstructorRoad } from "../constructor-roads-page.lib";

/** Ячейка «Процессы»: статусный тег «2 своя версии» (синий) / «Общие» (серый). */
export const RoadProcessesCell = (params: ICellRendererParams<ConstructorRoad>) => {
  const road = params.data;

  if (!road) {
    return null;
  }

  return (
    <Tag size="status" status={road.processes.isConfigured ? "IN_QUEUE" : "NEUTRAL"}>
      {road.processes.label}
    </Tag>
  );
};
